export function Eyebrow({ children }: { children: string }) {
  return (
    <span className="eyebrow">
      <span aria-hidden="true">—</span>
      {children}
    </span>
  );
}
